// extracted by mini-css-extract-plugin
module.exports = {"details":"VideoDetails_details__37_nu","image":"VideoDetails_image__3cEo2"};